import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";
import MDTypography from "components/MDTypography";
import SaveModal from "layouts/profile/components/AccountsTab/save-modal"
import { useMaterialUIController } from "context";

function AccountsTab() {
  const [controller] = useMaterialUIController();
  const { accounts } = controller;
  const [rows, setRows] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editAccount, setEditAccount] = useState(null);

  useEffect(() => { handleAccountChange() }, [accounts]);

  const handleAccountChange = async () => {
    setRows(accounts.map((account) => ({
      ...account,
      action: (
        <MDBox>
          <MDTypography component="a" href="#" variant="caption" color="info" fontWeight="medium" onClick={() => handleOpenEditModal(account)} mr={2}>
            Edit
          </MDTypography>
        </MDBox>
      ),
    })));
  };

  const handleOpenInsertModal = () => {
    setEditAccount(null);
    setOpenModal(true);
  };
  
  const handleOpenEditModal = (account) => {
    setEditAccount(account);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };
  
  const newButton = (<MDButton variant="outlined" color="info" size="small" onClick={() => handleOpenInsertModal()}>+</MDButton>);
  const columns = [
    { Header: "Name", accessor: "name", width: "45%", align: "left" },
    { Header: "Type", accessor: "type", align: "center" },
    { Header: "Report day", accessor: "start_day", align: "center" },
    { Header: "Currency", accessor: "currency", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  return (
    <MDBox pt={3} sx={{ overflowX: "auto", display: "block" }}>
      <DataTable table={{ columns, rows }} title="Accounts:" entriesPerPage={false} showTotalEntries={false} newButton={newButton} />
      <SaveModal open={openModal} handleClose={() => handleClose()} account={editAccount} />
    </MDBox>
  );
}

export default AccountsTab;
